// Token management for API authentication

export async function loginAndGetToken(): Promise<string | null> {
  // 1. Sprawdź czy zalogowany w SWA
  const response = await fetch('/.auth/me');
  const data = await response.json();

  if (!data.clientPrincipal) {
    // Nie zalogowany - przekieruj do Google
    window.location.href = '/.auth/login/google';
    return null;
  }

  // 2. Pobierz JWT token z SWA Function
  try {
    const tokenResponse = await fetch('/api/generate-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (tokenResponse.status === 403) {
      // Whitelist error
      const error = await tokenResponse.json();
      alert(error.message);
      await logout();
      return null;
    }

    if (!tokenResponse.ok) {
      throw new Error('Failed to get token');
    }

    const tokenData = await tokenResponse.json();

    // 3. Zapisz token (sessionStorage - znika po zamknięciu karty)
    sessionStorage.setItem('api_token', tokenData.access_token);

    return tokenData.access_token;
  } catch (error) {
    alert('Failed to authenticate. Please try again.');
    return null;
  }
}

export async function logout(): Promise<void> {
  // Remove session token
  sessionStorage.removeItem('api_token');

  // Redirect to SWA logout endpoint
  const origin = window.location.origin;
  window.location.href = `${origin}/.auth/logout`;
}

export function getToken(): string | null {
  return sessionStorage.getItem('api_token');
}

// Helper: dekoduj email z JWT (tylko do celów UI, bez weryfikacji podpisu)
export function getUserEmailFromToken(): string | null {
  const token = getToken();
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = JSON.parse(atob(parts[1]));
    return (payload?.email) ? String(payload.email) : null;
  } catch {
    return null;
  }
}

export function isTokenValid(): boolean {
  const token = getToken();
  if (!token) return false;

  try {
    // Decode JWT to check expiration (without verification)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    
    if (!exp) return false;
    
    // Check if token is expired (with 5 min buffer)
    const now = Math.floor(Date.now() / 1000);
    return exp > now + 300;
  } catch {
    return false;
  }
}
